import Utility from "../../../../utility/utility";
import LanguageManager from "../../../../manager/language_manager";
import GameUtil from "../../../../utility/game_util";
import ModelData, { IUserData } from "../../../public/model_data";
import UserDataManager from "../../../../manager/user_manager";
import ModuleManager from "../../../../framework/core/module_manager";
import PlayerIconModule from "../playericon/playerIcon";
import ComponentBase from "../../../public/component/component_base";
import Rank from "./rank";
import TablePlayerAvatar from "../../../table/components/table_player_avatar";

const {ccclass, property} = cc._decorator;

@ccclass
export default class RankHead extends ComponentBase {

    @property(cc.Sprite)
    indexSpr:cc.Sprite = null

    @property(cc.SpriteFrame)
    rankIndexSpr:cc.SpriteFrame[] = []

    @property(cc.Node)
    maxRankBtn:cc.Node = null

    @property(cc.Node)
    nodeAvatarParent: cc.Node = null

    @property(cc.Prefab)
    avatarPrefab: cc.Prefab = null


    protected m_avatar: TablePlayerAvatar = null

    itemData = null
    viewBase = null
    onLoad(){
        this.maxRankBtn.on("click", this.onOpenMaxRank, this)
    }

    setData( data: any, index: number, viewBase){
        this.viewBase = viewBase
        if (data == null){
            this.itemData = null
            this.m_avatar && this.m_avatar.show(false)
            return
        }
        let self = this
        this.itemData = data
        if (data.rank > 0 && data.rank <= 3){
            this.indexSpr.spriteFrame = this.rankIndexSpr[data.rank - 1]
            this.indexSpr.node.active = true
        }
        else{
            this.indexSpr.node.active = false
        }

        this.m_avatar = this.m_avatar || this.getAvatar()    
        this.m_avatar.isRankAvatar = true
        this.m_avatar.show(true, data.gameUserId)
        // UserDataManager.getAvatarSprite(data.headImg,(spriteFrame)=>{
        //     self.headIcon.spriteFrame = spriteFrame
            
        // });

    }

    getAvatar(): TablePlayerAvatar{
        let node = cc.instantiate(this.avatarPrefab)
        node.parent = this.nodeAvatarParent
        node.scale = 1
        node.position = cc.Vec3.ZERO
        return node.getComponent(TablePlayerAvatar)
    }


    onOpenMaxRank(){
        if (this.viewBase == null){ return }
        this.viewBase.rankDataByType = []
        this.viewBase.getRankDataByType(1, ()=>{
            ModuleManager.instance.showModule(Rank, this.viewBase.rankDataByType)
        })
    }

}
